import { Box, Icon, IconButton } from '@nimbus-ds/components';
import {
  BrowserIcon,
  CashIcon,
  MarketingIcon,
  GlassesIcon,
  ChatDotsIcon,
  OnlineStoreIcon,
  LockIcon,
  InfoCircleIcon,
} from '@nimbus-ds/icons';

interface RecommendationIconProps {
  type: string;
}

const getIcon = (type: string) => {
  switch (type) {
    case 'custom_domain':
      return <BrowserIcon size="small" />;
    case 'pos_config':
      return <CashIcon size="small" />;
    case 'marketing_app_config':
      return <MarketingIcon size="small" />;
    case 'specialist':
      return <GlassesIcon size="small" />;
    case 'online_store_config':
      return <OnlineStoreIcon size="small" />;
    case 'chat_config':
      return <ChatDotsIcon size="small" />;
    case 'lock':
      return <LockIcon size="small" />;
    case 'info':
      return <InfoCircleIcon size="small" />;
    default:
      return <BrowserIcon size="small" />;
  }
};

function RecommendationIcon({ type }: RecommendationIconProps) {
  return (
    <Box display="flex" alignItems="center">
      <IconButton
        size="1.5rem"
        source={<Icon source={getIcon(type)} color="primary-textLow" />}
      />
    </Box>
  );
}

export default RecommendationIcon;
